export default __webpack_public_path__ + "static/media/IMG_7847.5356a883.jpg";